
import axios from "axios";
import { checkStatus, getHeaders } from "../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";
const baseURL = process.env.REACT_APP_BASE_URL;

 
 export async function addSettings(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Org/Settings/Add`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }


  export async function getSettings(params) {
    try {
      const responses = await axiosInstance.post(`${baseURL}/Org/Settings`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(responses);
      return responses.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }